import type { InjectionKey } from 'vue';
import type { IIsMobilePlatformInjectedProps } from './useIsMobilePlatform';

export const IS_MOBILE_PLATFORM_INJECT_KEY = Symbol('isMobilePlatform') as InjectionKey<
  Readonly<IIsMobilePlatformInjectedProps>
>;
